import { Lesson } from "@jelly/lesson";

import principle01 from "./layouts/principle-01/principle";
import task01 from "./layouts/task-01/task";

const lesson: Lesson = {
  id: "bca7fcec-90cc-4500-b826-ad1d47d5de13",
  publicId: "14",
  name: "Acoustics of spaces for music",
  difficulty: 2,
  contentTypes: { audio: true, interactive: true, video: false },
  body: [principle01, task01],
};

export default lesson;
